import { IconButton, IconButtonProps, Typography } from '@material-ui/core'

import React from 'react'
import styled, { css } from 'styled-components'
import { directionalPadding } from './utils'
import MenuIcon from '@material-ui/icons/Menu'
import { ReactFC } from '../types'

export const ScreenContainer = styled.div`
display:flex;
flex-direction: column;
flex: 1;
background-color: #eee;
width: 100%;
height: 100%;
`

export const ScrollContainer = styled.div`
flex: 1;
display: flex;
overflow-y: hidden;
overflow-x: hidden;
`
export const ScrolledArea = styled.div<{ bottomBar?: boolean }>`
width: 100%;
flex: 1;
display: flex;
overflow-y: scroll;
overflow-x: hidden;
-webkit-overflow-scrolling: touch;
${({ bottomBar, theme }) => bottomBar && css`
    ${theme.breakpoints.down('xs')} {
    margin-bottom: ${theme.bottomNavSize}px;
  }
  `
}
`
export const ScrollContent = styled.div`
min-width: 100%;
max-width: 100%;
display: block;
`

export const MainSection: ReactFC<{ bottomBar?: boolean }> = ({ bottomBar = true, children }) => {
  return (
    // <ScrollContainer>
    <ScrolledArea bottomBar={bottomBar}>
      <ScrollContent>
        {React.Children.only(children)}
      </ScrollContent>
    </ScrolledArea>
    // </ScrollContainer>
  )
}

export const smallScreenBreakpoint = 667
export const hideSmallScreen = css`
  @media screen and (max-width: ${smallScreenBreakpoint}px) {
    display: none;  
  }
`
export const hideLargeScreen = css`
  @media screen and (min-width: ${smallScreenBreakpoint + 1}px) {
    display: none;  
  }
`

export const SmallPadded = styled.div`
  ${directionalPadding()}

  ${hideLargeScreen}
`

export const SmallScreenBottomPanel = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #666666;  

  ${hideLargeScreen}
`

export const ScreenContainerWithDrawer = styled(ScreenContainer)`
    ${({ theme }) => css`
    ${theme.breakpoints.up('sm')} {
        width: calc(100% - ${theme.appDrawer.width}px);
        div[dir=ltr][class=lang] & {
            margin-left: ${theme.appDrawer.width}px;
        }

        div[dir=rtl][class=lang] & {
            margin-right: ${theme.appDrawer.width}px;
        }    
    }
    `}
`

export const SmallScreenVisible = styled(IconButton)`
    ${({ theme }) => css`
    ${theme.breakpoints.up('sm')} {
        && {
            display: none;
        }
    }
    `}
`

export const LargeScreenVisible = styled(IconButton)`
    ${({ theme }) => css`
    ${theme.breakpoints.down('sm')} {
        && {
            display: none;
        }
    }
    `}
`

export const AppBarTitle = styled(Typography).attrs({
  variant: "h6",
})`
  && {
      margin-left: ${({ theme }) => theme.spacing(2)}px;
      margin-right: ${({ theme }) => theme.spacing(2)}px;
  }    
`

export const MenuButtonSmallScreen: ReactFC<IconButtonProps> = (props) => {
  return (
      <SmallScreenVisible
          color="inherit"
          aria-label="open drawer"
          edge="start"
          {...props as any}
      >
          <MenuIcon />
      </SmallScreenVisible>
  )
}

export const MenuButtonLargeScreen: ReactFC<IconButtonProps> = (props) => {
  return (
      <LargeScreenVisible
          color="inherit"
          aria-label="open drawer"
          edge="start"
          {...props as any}
      >
          <MenuIcon />
      </LargeScreenVisible>
  )
}

